module.exports = __webpack_public_path__ + "img/news14_7.0a70ee11.jpg";